<template>
  <label class="grid gap-1">
    <span class="text-xs font-semibold text-[#dde6f3]">
      {{ label }}
      <span v-if="required" class="ml-1 text-[#ffaa00]">*</span>
    </span>
    <span v-if="hint" class="text-xs text-[#91a0b4]">{{ hint }}</span>
    <slot></slot>
    <span v-if="error" class="text-xs text-[#fca5a5]">{{ error }}</span>
  </label>
</template>

<script>
export default {
  name: "PermissionField",
  props: {
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
